export default {
  data() {
    return {};
  },
  computed: {
    showNavigation() {
      // 从当前路由的元信息中获取是否显示底部导航栏
      return this.$route.meta.showNavigation !== false;
    }
  },
  mounted() {
    // 查询客服地址，暂时保留，后期动态
    // this.$store.dispatch('getiniinfoFn').then((res) => {
    //   console.log("resresres",res)
    // });
  }
};